import constants from '../constants/constants.json';

export function getLanguageFromCountry(country: string): {
  full_language: string;
  iso_639_1: string;
} {
  const foundCountry = constants.I18.LOCALES.find(
    locale => locale.code.toLowerCase() === country.toLowerCase()
  );

  if (foundCountry) {
    const languageTag =
      foundCountry?.languages[0] ||
      constants.I18.DEFAULT_LANGUAGE.split('-')[0];

    const language = constants.I18.SUPPORTED_LANGUAGES.find(
      supportedLanguage =>
        supportedLanguage.split('-')[0].toLowerCase() ===
        languageTag.toLowerCase()
    );

    if (language)
      return { full_language: language, iso_639_1: language?.split('-')[0] };
  }

  return {
    full_language: constants.I18.DEFAULT_LANGUAGE,
    iso_639_1: constants.I18.DEFAULT_LANGUAGE.split('-')[0]
  };
}
